import { useState } from "react";
import { Skeleton } from "primereact/skeleton";
import Section from "../section";
import { useIntl } from "react-intl";
import FormBuilder from "../formBuilder";
import Form from "../form";
import TooltipButton from "../tooltipButton";

import "./detail-card.scss";

// A field's value for the form: a date field's value as a Date, or null when
// it is empty. new Date(null) is the 1970 epoch, which an empty date showed
// as "01 January 1970" and saved with the card (F-BUG-3).
const formValue = (field) => {
  if (field.type.toLowerCase() !== "date") {
    return field.value;
  }
  const date = field.value ? new Date(field.value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

const DetailsCard = ({
  title,
  details,
  fields,
  isLoading,
  style = {},
  message,
  canUpdate = false,
  onSubmit = () => {},
}) => {
  const intl = useIntl();
  const [isEditabled, setIsEditabled] = useState(false);
  const isCompleted = fields.reduce((acc, field) => {
    acc = acc && (field.value ? true : false);
    return acc;
  }, true);

  const handleSubmit = (values) => {
    onSubmit(values);
    setIsEditabled(false);
  };

  return (
    <div
      className={`edexlms-details-card ${
        isCompleted ? "completed" : "incompleted"
      }`}
      style={style}
    >
      <Section
        title={title}
        i18n={false}
        headerAction={
          (!isEditabled && (
            <TooltipButton
              icon="pi pi-pencil"
              outlined
              onClick={() => setIsEditabled(!isEditabled) || null}
              label={intl.formatMessage({ id: "edit" })}
              type="button"
              size="small"
              disabled={!canUpdate}
              tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
              tooltip={
                canUpdate ? "" : intl.formatMessage({ id: "no_permission" })
              }
            />
          )) ||
          null
        }
      >
        {((isLoading || !details) && (
          <Skeleton width="100%" height="100px" />
        )) || <div className="edexlms-details-card"></div>}
        {(!isLoading && details && (
          <>
            <div>
              <Form
                submitBtn={{
                  label: intl.formatMessage({
                    id: "update",
                  }),
                  onClick: handleSubmit,
                }}
                cancelBtn={{
                  label: intl.formatMessage({ id: "cancel" }),
                  onClick: () => setIsEditabled(false),
                }}
                disabled={!isEditabled}
                initialValues={fields.reduce((acc, field) => {
                  const key = field.name || field.label;
                  acc[key] = field.value;
                  return acc;
                }, {})}
              >
                <FormBuilder
                  initialValues={fields.reduce((acc, field) => {
                    const key = field.name || field.label;
                    acc[key] = formValue(field);
                    return acc;
                  }, {})}
                  fields={fields}
                  disabled={!isEditabled}
                />
              </Form>
            </div>
            {(!isCompleted && !isEditabled && (
              <div className="text-muted">{message}</div>
            )) ||
              null}
          </>
        )) ||
          null}
        <div className="edexlms-details-completed">
          <i className="pi pi-check"></i>
        </div>
      </Section>
    </div>
  );
};

export default DetailsCard;
